/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import '../resources/card_holder';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "service": {
            "nested": {
              "ListCardHoldersRequest": {
                "fields": {
                  "creditLineToken": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "ListCardHoldersResponse": {
                "fields": {
                  "cardHolders": {
                    "type": ".squareup.corporate_card.resources.CardHolder",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListCardHoldersRequest && !$root.nested?.squareup?.nested?.corporate_card?.nested?.service?.nested?.ListCardHoldersResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE ListCardHoldersRequest @ squareup/corporate_card/service/list_card_holders.proto at 11:1
 */
export const ListCardHoldersRequest = $root.lookupType('squareup.corporate_card.service.ListCardHoldersRequest');
fixType(ListCardHoldersRequest, {
  creditLineToken: {
    required: true
  }
});
Builder.createAndAttachToType(ListCardHoldersRequest);
/**
 * SOURCE ListCardHoldersResponse @ squareup/corporate_card/service/list_card_holders.proto at 18:1
 */
export const ListCardHoldersResponse = $root.lookupType('squareup.corporate_card.service.ListCardHoldersResponse');
fixType(ListCardHoldersResponse);
Builder.createAndAttachToType(ListCardHoldersResponse);